<template>
	<div>
		<!-- Headline -->
		<div class="flex xs-12 xs-between">
			<div class="fs5 lh125 fw7 c1 mb2">Facts</div>
		</div>

		<!-- Body -->
		<j-card class="bg5">
			<!-- Items -->
			<j-list :list="facts">
				<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
					<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
						{{ item.label }}
					</div>
					<div class="flex xs-6 xs-right xs-middle lh125">
						{{ item.value | valueFilter }}
					</div>
				</div>
			</j-list>

			<!-- Empty -->
			<div class="bg5 ta2 fs3 p2" v-if="facts.length === 0">
				{{ $t("errors.no_data") }}
			</div>
		</j-card>
	</div>
</template>

<script>
import JCard from "@/components/JCard"
import JList from "@/components/JList"
import CoreModal from "@/modules/core/components/CoreModal"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"

export default {
	components: { JCard, JList, CoreModal, JButton, CrmIcon },
	props: {
		facts: {
			type: Array,
			default: () => []
		}
	},

	computed: {
		computedParticulars() {
			const data = this.particulars
			return [
				{
					label: this.$t("client"),
					value: get(data, "holder.name"),
					link: `/${this.$store.state.tenantId}/clients/detail/${get(
						data,
						"holder.id"
					)}/overview/${get(data, "holder.__typename")}`
				},
				{
					label: this.$t("start_date"),
					value: data.startDate
						? dayjs(data.startDate).format(
								this.$store.state.settings.dateFormat
						  )
						: null
				},
				{
					label: this.$t("end_date"),
					value: data.endDate
						? dayjs(data.endDate).format(this.$store.state.settings.dateFormat)
						: null
				},
				{
					label: this.$t("issue_date"),
					value: data.issueDate
						? dayjs(data.issueDate).format(
								this.$store.state.settings.dateFormat
						  )
						: null
				},
				{
					label: this.$t("referrer"),
					value: get(data, "referrer.name", null)
				},
				{ label: this.$t("source"), value: data.source },
				{
					label: this.$t("channel"),
					value: get(data, "client.name", "")
						? get(data, "client.name", "").toUpperCase()
						: get(data, "client.id", "").toUpperCase()
				}
			]
		}
	},

	filters: {
		valueFilter(val) {
			if (val === true) return "Yes"
			if (val === false) return "No"
			return val
		}
	}
}
</script>
